import closeItemReadingPane from '../actions/closeItemReadingPane';
import { getReadingPaneStore } from '../store/Store';
import { mutator } from 'satcheljs';

export default mutator(
    closeItemReadingPane,
    /* eslint-disable-next-line @typescript-eslint/no-unused-vars --
     * See aka.ms/mini-lint-errors
     *	> 'actionMessage' is defined but never used. */
    function closeItemReadingPaneMutator(actionMessage: {}) {
        getReadingPaneStore().itemReadingPaneViewState = null;
    }
);
